export default __webpack_public_path__ + "static/media/carwash.c429c3d1.gif";